import { render, staticRenderFns } from "./indexHomePage.vue?vue&type=template&id=2cf40d86&scoped=true&"
import script from "./indexHomePage.vue?vue&type=script&lang=js&"
export * from "./indexHomePage.vue?vue&type=script&lang=js&"
import style0 from "./indexHomePage.vue?vue&type=style&index=0&id=2cf40d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf40d86",
  null
  
)

export default component.exports